import styled from 'styled-components'

const LivechatEnablerBlock = styled.div`
  border-bottom: 1px solid var(--color-issabeline-grey);
  padding-bottom: 32px;
  margin-bottom: 32px;
`
export { LivechatEnablerBlock }
